export var BERRY_EVENT_ORIGIN = 'https://widget.berryapp.io';
export var BERRY_APP_HOST = 'https://www.berryapp.io';
export var BERRY_APP_WIDGET_PATH = 'js/berry-widget.min.js';
export var BERRY_APP_WIDGET_URL = BERRY_APP_HOST + "/" + BERRY_APP_WIDGET_PATH;
export var LOGGER_NAME = 'berry';
export var BERRY_ELEMENT_ID = 'BerryappChatWidget';
export var ADMIN_BOT_NAME = 'nova-external-admins';
export var LEARNER_BOT_NAME = 'nova-external-learners';
export var BERRY_APP_EVENT_HANDLERS_TYPES = {
    BERRY_HANDOFF_EVENT: 'berryHandOffToAgent',
    BERRY_WIDGET_HANDSHAKE: 'berryWidgetHandshake',
};
export var BERRY_API_TOKEN_ENDPOINT = '/berry/get-token';
export var BERRY_ENABLED_TYPES = {
    ADMIN: 'ADMIN',
    LEARNER: 'LEARNER',
    BOTH: 'BOTH',
    NONE: 'NONE',
};
//# sourceMappingURL=constant.js.map